const en_sales_recap = {
    "": "sales invoice recap",
    add: "add sales invoice recap",
    detail: "sales invoice recap detail",

    label: {
        no_recap: "recap invoice no",
        inv_choose: "select invoice",
        inv_selected: "selected invoice:",
    },

    error: {
        create: "Failed to create sales invoice recap.",
        edit: "Failed to update sales invoice recap.",
    },

    success: {
        create: "Sales invoice recap created successfully.",
        edit: "Sales invoice recap updated successfully.",
    },
}

export default en_sales_recap;